function MFRLikes(index, element) {
  this.$element = $(element)

  this.selectors = {
    slider: ".section-grid",
    heart: ".heart"
  }

  this.init()
}

MFRLikes.prototype = Object.assign({}, MFRLikes.prototype, {
  init: function () {
    this.$slider = this.$element.find(this.selectors.slider)
    this.$heart = this.$element.find(this.selectors.heart)
    
    $(window).on("load", this.__handleSliderInit.bind(this))
    $(window).on("resize", this.__handleSliderInit.bind(this))
  },

  __handleSliderInit: function() {
    if (matchMedia('screen and (max-width: 1023px)').matches) {
      this.$slider.flickity({
        pageDots: true,
        prevNextButtons: false,
        contain: true
      })
    } else {
      this.$slider.flickity()
      this.$slider.flickity('destroy')
    }
  }
})